import * as React from 'react';

import {colors} from '../colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {LoadingIcon} from '../icon/svg/loading-icon';
import {RelativeOverlay} from '../relative-overlay/relative-overlay';

export function LoadingOverlay() {
    return (
        <RelativeOverlay isOpaque={false}>
            <LoadingIcon fill={colors.greyLt} />
        </RelativeOverlay>
    );
}
